module.exports = __webpack_public_path__ + "img/lactation_room.a7a94033.png";